import $ from 'domtastic';

class RentMobile {

  constructor() {
    this.cacheDom();
    this.bindEvents();
  }

  cacheDom() {
    this.$invoker = $('.js-rent-mobile-invoker');
    this.$menu = $('.js-rent-mobile-menu');
    this.$container = this.$menu.parent();
    this.$overlay = $('.js-mobile-overlay-rent');
  }

  bindEvents() {
    this.$invoker.on('click', (event) => {
      event.preventDefault();
      const $invoker = $(event.target);

      if ($invoker.hasClass('-active')) {
        this.close();
      } else {
        this.open($invoker);
      }
    });

    this.$overlay.on('click', () => this.close());
  }

  open($invoker) {
    this.showOverlay();
    this.$container.addClass('-active');
    this.$invoker.removeClass('-active');
    $invoker.addClass('-active');
    this.$menu.removeClass('-hidden');
    this.$menu.addClass('-visible');
  }

  close() {
    this.$invoker.removeClass('-active');
    this.$menu.removeClass('-visible');
    this.$menu.on('transitionend', () => {
      this.$container.removeClass('-active');
      this.$menu.addClass('-hidden');
      this.$menu.off();
    });
    this.hideOverlay();
  }

  closeDirect() {
    this.hideOverlay();
    this.$invoker.removeClass('-active');
    this.$menu.removeClass('-visible');
    this.$container.removeClass('-active');
    this.$menu.addClass('-hidden');
    this.$menu.off();
  }

  showOverlay() {
    this.$overlay.addClass('-rent -visible');
  }

  hideOverlay() {
    this.$overlay.removeClass('-rent -visible');
  }
}

export default new RentMobile();



// WEBPACK FOOTER //
// ./components/RentMobile.js